import { Field } from "./StepAboutYou";
import { SITE } from "@/lib/site";

export const StepDetails = ({ form, errors, onChange }) => (
  <div data-testid="quote-step-5">
    <Field id="details" label="Tell us about your business and what you'd like your website to do." error={errors.details} hint="Include anything useful — your industry, pages you'd like, examples of websites you like, or timelines.">
      <textarea
        id="details"
        name="details"
        rows={7}
        className={`field-input resize-y min-h-[180px] ${errors.details ? "field-error" : ""}`}
        placeholder="For example: We're a landscaping business in need of a website that shows our services, recent work and makes it easy for customers to request a quote..."
        value={form.details}
        onChange={onChange}
        aria-invalid={!!errors.details}
        aria-describedby={errors.details ? "details-error" : undefined}
        data-testid="quote-input-details"
        required
      />
    </Field>
  </div>
);

const Row = ({ label, value, testId }) => (
  <div className="flex flex-col sm:flex-row sm:justify-between gap-1 border-b border-white/[0.06] py-3 last:border-0 text-sm">
    <dt className="text-slate-500">{label}</dt>
    <dd className="text-slate-100 sm:text-right sm:max-w-[60%] break-words" data-testid={testId}>{value || "—"}</dd>
  </div>
);

export const StepReview = ({ form }) => (
  <div data-testid="quote-step-6">
    <p className="text-sm text-slate-400 mb-4">Please check your details before submitting your quote request.</p>
    <dl className="rounded-2xl border border-white/[0.08] bg-white/[0.02] px-5">
      <Row label="Full name" value={form.full_name} testId="review-full-name" />
      <Row label="Business" value={form.business_name} testId="review-business-name" />
      <Row label="Phone" value={form.phone} testId="review-phone" />
      <Row label="Email" value={form.email} testId="review-email" />
      <Row label="Website type" value={form.website_type} testId="review-website-type" />
      <Row label="Features" value={form.features.length ? form.features.join(", ") : "None selected"} testId="review-features" />
      <Row label="Budget range" value={form.budget} testId="review-budget" />
      <Row label="Project details" value={form.details} testId="review-details" />
    </dl>
    <div className="mt-4 rounded-2xl border border-indigo-400/20 bg-indigo-500/[0.06] px-4 py-3 text-xs sm:text-sm text-slate-300" data-testid="review-deposit-note">
      <p>
        Good to know: once you're happy with your quote, a <span className="font-semibold text-white">${SITE.deposit} deposit</span> secures your project. Most websites are completed in <span className="font-semibold text-white">{SITE.timeline}</span>, depending on size and requirements. Submitting this form doesn't commit you to anything.
      </p>
      <p className="mt-2 border-t border-white/[0.08] pt-2 text-slate-400">
        Payment details: invoices are issued by <span className="text-slate-200">{SITE.name}</span> · ABN <span className="font-mono text-slate-200" data-testid="review-abn">{SITE.abn}</span>. Payment details and the amount due are shown on your invoice.
      </p>
    </div>
  </div>
);
